module.exports = __webpack_public_path__ + "img/sunstar.82316b23.png";